export var VideoType;
(function (VideoType) {
    VideoType["H264"] = "H264";
    VideoType["HLS"] = "HLS";
    VideoType["MPEG4"] = "MPEG4";
    VideoType["OGG"] = "OGG";
    VideoType["VP9"] = "VP9";
    VideoType["WEBM"] = "WEBM";
})(VideoType || (VideoType = {}));
